import * as React from 'react';
import * as COLOURS from '../../../constants/colours';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

import Select from '@mui/material/Select';

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            padding: 0,
            '& fieldset': {
              border: 'none',
            },

            '.MuiInputBase-input': {
              padding: 0,
              paddingTop: 8,
              paddingBottom: 8,
            },
            svg: {
              color: COLOURS.soltaColor,
            },
            p: {
              fontSize: 16,
              fontWeight: 300,
              color: '#707070',
            },
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            li: {
              img: {
                maxHeight: 28,
                width: 'auto',
                textAlign: 'center',
              },
            },
          },
        },
      },
    },
  });

export default function SoltaSelect(props) {
  const { children } = props;

  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <Select {...props} fullWidth>
        {children}
      </Select>
    </ThemeProvider>
  );
}
